import { type ReportHandler } from 'web-vitals';

import { isDefined } from './utilities/types';

const reportWebVitals = (onPerfEntry?: ReportHandler): void => {
  if (isDefined(onPerfEntry) && onPerfEntry instanceof Function) {
    void import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
      return null;
    });
  }
};

export default reportWebVitals;
